<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import JsonExcel from "vue-json-excel";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import getMonth from "@/filters/get-month";
import store from "@/state/store";
export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    if (userType === 1 || userType === 3) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Approved Salary Routine",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    JsonExcel,
  },
  async mounted() {
    await this.fetchPaymentDefinitions();
  },
  methods: {
    approveRoutine() {
      this.submitted = true;

      const data = {
        pmyl_location_id: this.$route.params.locationId,
      };
      //console.log(data)
      const url = `${this.ROUTES.salary}/approve-salary-routine`;
      this.apiPost(url, data, "Salary Approval").then((res) => {
        this.apiResponseHandler(`${res.data}`, "Salary Confirmed");
        this.$router.push({ name: "approve-payroll" });
      });
    },
    fetchPaymentDefinitions() {
      this.paymentDefinitions = [];
      const url = `${this.ROUTES.paymentDefinition}/employee-payment-definition`;
      this.apiGet(url, "Get Payment Definitions Error").then(async (res) => {
        const { data } = res;
        this.paymentDefinitions = data;
        await this.processFields(data);
        this.newFields.push(...this.incomeFields);
        this.newFields.push(...this.deductionFields);
        this.newFields.push("grossSalary");
        this.newFields.push("totalDeduction");
        this.newFields.push("netSalary");

        this.otherFields.push("authorizedBy");
        this.otherFields.push("dateAuthorized");
        this.otherFields.push("approvedBy");
        this.otherFields.push("dateApproved");
        this.otherFields.push("confirmedBy");
        this.otherFields.push("dateConfirmed");
        this.otherFields.push("location");

        this.newFields.forEach((newField) => {
          if (newField === "sn") {
            this.jsonFields["S/N"] = newField;
          } else if (newField === "t7_number") {
            this.jsonFields["T7 NUMBER"] = "employeeUniqueId";
          } else if (newField === "employeeName") {
            this.jsonFields["EMPLOYEE NAME"] = newField;
          } else if (newField === "netSalary") {
            this.jsonFields["NET SALARY"] = newField;
          } else if (newField === "grossSalary") {
            this.jsonFields["GROSS SALARY"] = newField;
          } else if (newField === "totalDeduction") {
            this.jsonFields["TOTAL DEDUCTION"] = newField;
         /* }else if(newField === 'authorizedBy'){
            this.jsonFields['Authorized By'] = newField;
          }else if(newField === 'dateAuthorized'){
            this.jsonFields['Date Authorized'] = newField;
          }else if(newField === 'approvedBy'){
            this.jsonFields['Approved By'] = newField;
          }else if(newField === 'dateApproved'){
            this.jsonFields['Date Approved'] = newField;
          }else if(newField === 'confirmedBy'){
            this.jsonFields['Confirmed By'] = newField;
          }else if(newField === 'dateConfirmed'){
            this.jsonFields['Date Confirmed'] = newField;
          }else if(newField === 'location'){
            this.jsonFields['Location'] = newField;*/
          } else {
            this.jsonFields[newField.toUpperCase()] = newField;
          }
        });
        await this.refreshTable();

      });

    },
    async refreshTable() {
      let locationId = this.$route.params.locationId;
      let year = this.$route.params.year;
      let month = this.$route.params.month;
      this.period[0] = month;
      this.period[1] = year;
      // this.period = this.$route.params.period.split("-");
      // this.location = this.$route.params.locationID;
      let data = {
        pym_month: parseInt(month),
        pym_year: parseInt(year),
        pmyl_location_id: locationId,
      };
      const url = `${this.ROUTES.salary}/pull-emolument`;
      this.apiPost(url, data, "Generate Emolument Report").then(async (res) => {
        const {data}  = res;
        this.otherDetails = data.otherDetails;
        this.locationName = this.otherDetails?.location?.location?.location_name;
        this.locationT6Code = this.otherDetails?.location?.location?.l_t6_code;
        this.employeeFirstName = this.otherDetails?.confirmedBy?.confirmedBy?.emp_first_name
        this.employeeLastName = this.otherDetails?.confirmedBy?.confirmedBy?.emp_last_name;
        this.employeeOtherNames = this.otherDetails?.confirmedBy?.confirmedBy?.emp_other_name;
        this.employeeUniqueId = this.otherDetails?.confirmedBy?.confirmedBy?.emp_unique_id;
        this.employeePmConfirmedDate = new Date(this.otherDetails?.confirmedBy?.pmyl_confirmed_date).toLocaleDateString();

        this.authorizedByEmployeeFirstName = this.otherDetails?.authorisedBy?.authorizedBy?.emp_first_name
        this.authorizedByEmployeeLastName = this.otherDetails?.authorisedBy?.authorizedBy?.emp_last_name;
        this.authorizedByEmployeeOtherNames = this.otherDetails?.authorisedBy?.authorizedBy?.emp_other_name;
        this.authorizedByEmployeeUniqueId = this.otherDetails?.authorisedBy?.authorizedBy?.emp_unique_id;
        this.authorisedByEmployeePmConfirmedDate = new Date(this.otherDetails?.authorisedBy?.pmyl_authorised_date).toLocaleDateString();

        this.approvedByEmployeeFirstName = this.otherDetails?.approvedBy?.approvedBy?.emp_first_name
        this.approvedByEmployeeLastName = this.otherDetails?.approvedBy?.approvedBy?.emp_last_name;
        this.approvedByEmployeeOtherNames = this.otherDetails?.approvedBy?.approvedBy?.emp_other_name;
        this.approvedByEmployeeUniqueId = this.otherDetails?.approvedBy?.approvedBy?.emp_unique_id;
        this.approvedByEmployeePmConfirmedDate = new Date(this.otherDetails?.approvedBy?.pmyl_approved_date).toLocaleDateString();

        this.signOffs = [
          this.buildSignOff(
            this.otherDetails?.confirmedBy?.confirmedBy,
            this.otherDetails?.confirmedBy?.pmyl_confirmed_date,
            "Prepared By",
            "Confirmed"
          ),
          this.buildSignOff(
            this.otherDetails?.authorisedBy?.authorizedBy,
            this.otherDetails?.authorisedBy?.pmyl_authorised_date,
            "Reviewed By",
            "Authorized"
          ),
          this.buildSignOff(
            this.otherDetails?.approvedBy?.approvedBy,
            this.otherDetails?.approvedBy?.pmyl_approved_date,
            "Approved By",
            "Approved"
          ),
        ];

        //console.log(this.otherDetails?.approvedBy?.approvedBy)
        this.jsonFields["Company Name"] = "Test";
        const newData = await this.sortArrayOfObjects(this.reportRows(data.employeeSalary));
        newData.forEach((emolument, index) => {
          let emolumentObj = {
            sn: ++index,
            employeeId: emolument.employeeId,
            employeeUniqueId: emolument.employeeUniqueId,
            employeeName: emolument.employeeName,
            location: emolument.location,
            sector: emolument.sector,
            jobRole: emolument.jobRole,
            salaryGrade: emolument.salaryGrade,
            contractStartDate: emolument.employeeStartDate,
            contractEndDate: emolument.empEndDate,
          };
          emolument.incomes.forEach((income) => {
            emolumentObj[income.paymentName] = this.apiValueHandler(
              income.amount.toFixed(2)
            );
          });
          emolument.deductions.forEach((deduction) => {
            emolumentObj[deduction.paymentName] = this.apiValueHandler(
              deduction.amount.toFixed(2)
            );
          });
          emolumentObj["grossSalary"] = this.apiValueHandler(
            emolument.grossSalary.toFixed(2)
          );
          emolumentObj["totalDeduction"] = this.apiValueHandler(
            emolument.totalDeduction.toFixed(2)
          );
          emolumentObj["netSalary"] = this.apiValueHandler(
            emolument.netSalary.toFixed(2)
          );
          emolumentObj['authorizedBy'] = `${this.otherDetails?.authorisedBy?.authorizedBy?.emp_first_name} ${this.otherDetails?.authorisedBy?.authorizedBy?.emp_last_name} ${this.otherDetails?.authorisedBy?.authorizedBy?.emp_other_name} (${this.otherDetails?.authorisedBy?.authorizedBy?.emp_unique_id})`;
          emolumentObj['dateAuthorized'] = `${new Date(this.otherDetails?.authorisedBy?.pmyl_authorised_date).toLocaleDateString()}`;

          emolumentObj['approvedBy'] = `${this.otherDetails?.approvedBy?.approvedBy?.emp_first_name} ${this.otherDetails?.approvedBy?.approvedBy?.emp_last_name} ${this.otherDetails?.approvedBy?.approvedBy?.emp_other_name} (${this.otherDetails?.approvedBy?.approvedBy?.emp_unique_id})`;
          emolumentObj['dateApproved'] = `${new Date(this.otherDetails?.approvedBy?.pmyl_approved_date).toLocaleDateString()}`;

          emolumentObj['confirmedBy'] = `${this.otherDetails?.confirmedBy?.confirmedBy?.emp_first_name} ${this.otherDetails?.confirmedBy?.confirmedBy?.emp_last_name} ${this.otherDetails?.confirmedBy?.confirmedBy?.emp_other_name} (${this.otherDetails?.confirmedBy?.confirmedBy?.emp_unique_id})`;
          emolumentObj['dateConfirmed'] = `${new Date(this.otherDetails?.approvedBy?.pmyl_confirmed_date).toLocaleDateString()}`;

          emolumentObj['location'] =  `${this.otherDetails?.location?.location?.location_name} (${this.otherDetails?.location?.location?.l_t6_code})`;

          this.newEmoluments.push(emolumentObj);
        });
        this.filtered = this.newEmoluments;
        this.totalRows = this.newEmoluments.length;
        //console.log(this.filtered)
        console.log(this.jsonFields)

      });
    },

    async sortArrayOfObjects(array) {
      return array.sort(function (a, b) {
        let matchesA = a.employeeUniqueId.match(/(\d+)/);
        matchesA = parseInt(matchesA[0]);

        let matchesB = b.employeeUniqueId.match(/(\d+)/);
        matchesB = parseInt(matchesB[0]);

        return matchesA - matchesB;
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.filtered = filteredItems;
      this.currentPage = 1;
    },
    decimalPlaces(float, length) {
      let ret = "";
      let str = float.toString();
      let array = str.split(".");
      if (array.length === 2) {
        ret += array[0] + ".";
        for (let i = 0; i < length; i++) {
          if (i >= array[1].length) ret += "0";
          else ret += array[1][i];
        }
      } else if (array.length === 1) {
        ret += array[0] + ".";
        for (let i = 0; i < length; i++) {
          ret += "0";
        }
      }
      return ret;
    },

    async processFields(data) {
      await data.forEach((paymentDefinition, index) => {
        if (paymentDefinition.pd_payment_type === 1) {
          this.incomeFields.push(data[index].pd_payment_name);
        } else if (paymentDefinition.pd_payment_type === 2) {
          this.deductionFields.push(data[index].pd_payment_name);
        }
      });
    },

    buildSignOff(employee, dateValue, role, action) {
      const person = employee || {};
      const name = [person.emp_first_name, person.emp_other_name, person.emp_last_name]
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();
      return {
        role,
        action,
        name: name || "—",
        title: person.jobrole?.job_role || action,
        staffId: person.emp_unique_id || "",
        date: this.formatSignDate(dateValue),
        signature: person.emp_signature || "",
      };
    },
    formatSignDate(value) {
      const date = new Date(value);
      if (!value || Number.isNaN(date.getTime())) return "";
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    generatePdf() {
      if (!this.newEmoluments.length) return;

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a3",
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const monthName = getMonth(parseInt(this.period[0], 10) - 1) || "";
      const periodLabel = `${monthName} ${this.period[1] || ""}`.trim();
      const locationLabel = this.locationName
        ? `${this.locationName} (${this.locationT6Code || ""})`
        : "All locations";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(20, 20, 20);
      doc.text("Approved Salary Report", 28, 32);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(70, 70, 70);
      doc.text(`Payroll period: ${periodLabel}`, 28, 50);
      doc.text(`Location: ${locationLabel}`, 28, 64);

      const textFields = new Set([
        "sn",
        "t7_number",
        "employeeName",
        "sector",
        "location",
        "jobRole",
        "salaryGrade",
        "contractStartDate",
        "contractEndDate",
      ]);
      const columnStyles = {};
      this.newFields.forEach((field, index) => {
        if (!textFields.has(field)) {
          columnStyles[index] = { halign: "right" };
        }
      });

      autoTable(doc, {
        startY: 78,
        head: [this.newFields.map((field) => this.pdfHeader(field))],
        body: this.newEmoluments.map((row) =>
          this.newFields.map((field) => String(this.pdfCell(row, field)))
        ),
        styles: {
          fontSize: 6,
          cellPadding: 2,
          overflow: "linebreak",
          textColor: [33, 37, 41],
        },
        headStyles: {
          fillColor: [33, 37, 41],
          textColor: 255,
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles,
        margin: { left: 24, right: 24, top: 28, bottom: 36 },
      });

      this.drawSignOff(doc);
      const pageCount = doc.internal.getNumberOfPages();
      const footer = `Approved Salary Report  ·  ${periodLabel}  ·  ${locationLabel}`;
      for (let page = 1; page <= pageCount; page += 1) {
        doc.setPage(page);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text(footer, 24, doc.internal.pageSize.getHeight() - 16);
        doc.text(
          `Page ${page} of ${pageCount}`,
          pageWidth - 24,
          doc.internal.pageSize.getHeight() - 16,
          { align: "right" }
        );
      }
      const safeLocation = (this.locationT6Code || "location").replace(/\s+/g, "_");
      doc.save(`Approved_Salary_Report_${safeLocation}_${this.period[0]}-${this.period[1]}.pdf`);
    },
    drawSignOff(doc) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const blockHeight = 168;
      let y = (doc.lastAutoTable?.finalY || 78) + 28;
      if (y + blockHeight > pageHeight - 36) {
        doc.addPage();
        y = 40;
      }

      doc.setDrawColor(210);
      doc.line(28, y, pageWidth - 28, y);
      y += 18;

      const margin = 28;
      const gap = 18;
      const colWidth = (pageWidth - margin * 2 - gap * 2) / 3;
      this.signOffs.forEach((person, index) => {
        this.drawSignatory(doc, person, margin + index * (colWidth + gap), y, colWidth);
      });
    },
    drawSignatory(doc, person, x, y, width) {
      const center = x + width / 2;
      doc.setTextColor(20, 20, 20);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      const nameLines = doc.splitTextToSize(person.name || "—", width - 8);
      doc.text(nameLines, center, y + 14, { align: "center" });

      let cursor = y + 14 + nameLines.length * 15;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(55, 55, 55);
      doc.text(person.title || "", center, cursor, { align: "center" });
      cursor += 14;
      if (person.staffId) {
        doc.setFontSize(9);
        doc.text(person.staffId, center, cursor, { align: "center" });
        cursor += 12;
      }

      const boxWidth = Math.min(190, width - 24);
      const boxHeight = 54;
      const boxX = center - boxWidth / 2;
      cursor += 4;
      doc.setDrawColor(190);
      doc.setFillColor(255, 255, 255);
      doc.rect(boxX, cursor, boxWidth, boxHeight, "S");
      if (person.signature) {
        const format = /image\/jpe?g/i.test(person.signature) ? "JPEG" : "PNG";
        try {
          doc.addImage(
            person.signature,
            format,
            boxX + 6,
            cursor + 4,
            boxWidth - 12,
            boxHeight - 8
          );
        } catch (error) {
          doc.setFontSize(8);
          doc.setTextColor(140);
          doc.text("Signature unavailable", center, cursor + 30, { align: "center" });
        }
      } else {
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text("No signature on file", center, cursor + 30, { align: "center" });
      }

      cursor += boxHeight + 16;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      doc.setTextColor(20, 20, 20);
      doc.text(person.date || "", center, cursor, { align: "center" });
      cursor += 18;
      doc.setFontSize(9);
      doc.setTextColor(110);
      doc.text(person.role, center, cursor, { align: "center" });
    },
    pdfCell(row, field) {
      if (field === "t7_number") return row.employeeUniqueId || "";
      const value = row[field];
      return value == null ? "" : value;
    },
    pdfHeader(field) {
      const labels = {
        sn: "S/N",
        t7_number: "T7",
        employeeName: "Employee",
        sector: "Sector",
        location: "Location",
        jobRole: "Role",
        salaryGrade: "Grade",
        contractStartDate: "Start",
        contractEndDate: "End",
        grossSalary: "Gross",
        totalDeduction: "Deductions",
        netSalary: "Net",
      };
      return labels[field] || field;
    },

    selectRow(row) {
      row = row[0];
      //console.log(row);
      let empID = row.employeeId;
      let year = this.period[1];
      let month = this.period[0];

      this.$router.push({
        name: "view-approved-salary-routine-payslip",
        params: { empID, month, year },
      });
      this.$refs["emolument-table"].clearSelected();
    },
  },
  data() {
    return {
      locationName: '',
      locationT6Code:'',
      employeeFirstName: '',
      employeeLastName: '',
      employeeOtherNames: '',
      employeeUniqueId: '',
      employeePmConfirmedDate: '',

      authorizedByEmployeeFirstName: '',
      authorizedByEmployeeLastName: '',
      authorizedByEmployeeOtherNames: '',
      authorizedByEmployeeUniqueId: '',
      authorisedByEmployeePmConfirmedDate: '',

      approvedByEmployeeFirstName: '',
      approvedByEmployeeLastName: '',
      approvedByEmployeeOtherNames: '',
      approvedByEmployeeUniqueId: '',
      approvedByEmployeePmConfirmedDate: '',
      signOffs: [],


      title: "Approved Salary Report",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Approved Salary Report",
          active: true,
        },
      ],
      json_fields: {
        "Complete name": "name",
        City: "city",
        Telephone: "phone.mobile",
        "Telephone 2": {
          field: "phone.landline",
          callback: (value) => {
            return `Landline Phone - ${value}`;
          },
        },
      },
      json_data: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010",
          },
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244",
          },
        },
      ],
      period: [],
      emoluments: [],
      filtered: [],
      newEmoluments: [],
      paymentDefinitions: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "sn",
      sortDesc: false,
      newFields: [
        "sn",
        "t7_number",
        "employeeName",
        "sector",
        "location",
        "jobRole",
        "salaryGrade",
        "contractStartDate",
        "contractEndDate",
      ],
      otherFields : [],
      incomeFields: [],
      deductionFields: [],
      jsonFields: {},
      location: null,
      otherDetails:null,
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button
        class="btn btn-success mr-3"
        :disabled="!newEmoluments.length"
        @click="generatePdf"
      >
        <i class="mdi mdi-file-pdf mr-2"></i>
        Download PDF
      </b-button>
      <b-button class="btn btn-success" @click="$router.go(-1)">
        <i class="mdi mdi-arrow-left mr-2"></i>
        Go Back
      </b-button>
    </div>
    <scale-loader v-if="apiBusy" />
    <div v-else class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <h5 class="font-size-14 mb-0" v-if="period.length">
                Emolument Report For Payroll Period:
                {{ (parseInt(period[0]) - 1) | getMonth }}
                {{ period[1] }}
              </h5>
              <span class="font-size-12 text-success">
                <JsonExcel
                  style="cursor: pointer"
                  :data="filtered"
                  :fields="jsonFields"
                  :name="`Emolument_Report(${period[0]}-${period[1]}).xls`"
                >
                  Export to Excel
                </JsonExcel>
              </span>
            </div>

            <div class="signoff-row bg-light">
              <div
                v-for="person in signOffs"
                :key="person.role"
                class="signoff-card"
              >
                <p class="signoff-name">{{ person.name }}</p>
                <p class="signoff-title">{{ person.title }}</p>
                <p v-if="person.staffId" class="signoff-id">{{ person.staffId }}</p>
                <div class="signoff-box">
                  <img
                    v-if="person.signature"
                    :src="person.signature"
                    :alt="`${person.name} signature`"
                  />
                  <span v-else>No signature on file</span>
                </div>
                <p class="signoff-date">{{ person.date }}</p>
                <p class="signoff-role">{{ person.role }}</p>
              </div>
            </div>
            <p class="mt-2 mb-0">
              <strong>Location:</strong>
              {{ locationName }}
              ({{ locationT6Code }})
            </p>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="newEmoluments.length">
              <b-table
                selectable
                ref="emolument-table"
                bordered
                hover
                small
                :items="newEmoluments"
                :fields="newFields"
                striped
                responsive="lg"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                select-mode="single"
                @row-selected="selectRow"
                show-empty
              >
                <template #cell(sn)="row">
                  <span>
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(t7_number)="row">
                  <span>
                    {{ row.item.employeeUniqueId }}
                  </span>
                </template>
                <template #cell(employeeName)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(sector)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(location)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(jobRole)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell()="data">
                  <span class="text-nowrap float-right">{{ data.value }}</span>
                </template>
                <template #cell(grossSalary)="row">
                  <span class="float-right">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(netSalary)="row">
                  <span class="float-right">
                    {{ row.value }}
                  </span>
                </template>
              </b-table>
            </div>
            <div v-else>
              <p class="text-center my-5">
                Populating report table, please wait...
              </p>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
<style>
.signoff-row {
  display: flex;
  gap: 16px;
  padding: 16px;
}
.signoff-card {
  flex: 1;
  text-align: center;
}
.signoff-name {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 600;
}
.signoff-title,
.signoff-id,
.signoff-date {
  margin-bottom: 0;
}
.signoff-title {
  color: #495057;
}
.signoff-id,
.signoff-role {
  color: #6c757d;
  font-size: 13px;
}
.signoff-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
  margin: 10px auto;
  max-width: 220px;
  background: #fff;
  border: 1px solid #ced4da;
}
.signoff-box img {
  max-width: 100%;
  max-height: 64px;
  object-fit: contain;
}
.signoff-box span {
  color: #adb5bd;
  font-size: 12px;
}
.signoff-date {
  margin-top: 4px;
}
.signoff-role {
  margin-top: 8px;
  margin-bottom: 0;
  letter-spacing: 0.02em;
}
</style>
